'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Attribute = require('../abstract/attribute');
var DataTypes = require('./data_types');
var _a = require('./sqlstring'), escape = _a.escape, escapeId = _a.escapeId;
var SqliteAttribute = /** @class */ (function (_super) {
    __extends(SqliteAttribute, _super);
    function SqliteAttribute(name, params, opts) {
        return _super.call(this, name, params, opts) || this;
    }
    Object.defineProperty(SqliteAttribute, "DataTypes", {
        get: function () {
            return DataTypes;
        },
        enumerable: false,
        configurable: true
    });
    SqliteAttribute.prototype.toSqlString = function () {
        var _a = this, columnName = _a.columnName, columnType = _a.columnType, type = _a.type, allowNull = _a.allowNull, defaultValue = _a.defaultValue, primaryKey = _a.primaryKey, unique = _a.unique;
        var chunks = [
            escapeId(columnName),
            columnType.toUpperCase() || type.toSqlString(),
        ];
        if (primaryKey)
            chunks.push('PRIMARY KEY');
        // https://www.cyj.me/programming/2018/01/11/programming-leoric-ii/
        if (this.autoIncrement)
            chunks.push('AUTOINCREMENT');
        if (!primaryKey && !allowNull)
            chunks.push('NOT NULL');
        if (unique === true) {
            chunks.push('UNIQUE');
        }
        if (defaultValue != null) {
            chunks.push("DEFAULT ".concat(escape(defaultValue)));
        }
        return chunks.join(' ');
    };
    return SqliteAttribute;
}(Attribute));
module.exports = SqliteAttribute;
//# sourceMappingURL=attribute.js.map